export default {
    
    setToken (access_token, expires_in, user) {
        localStorage.setItem('access_token', access_token)
        localStorage.setItem('expires_in', expires_in)
        localStorage.setItem('user', user)
    },

    getToken () {
        let token = localStorage.getItem('access_token')
        let expiration = localStorage.getItem('expires_in')

        if (! token || ! expiration) {
            return null

        }
        else {
            return token
        }
    },

    getAuthenticatedUser() {
        if (localStorage.getItem('user')) {
            return JSON.parse(localStorage.getItem('user'));
        }

        return null;
    },
    
    destroyToken () {
        window.gapi.load('auth2', () => {
            const auth2 = window.gapi.auth2.init();
        })
        var auth3 = window.gapi.auth2.getAuthInstance();
            auth3.signOut().then(function () {
            console.log('User signed out of google.');
        });

        localStorage.removeItem('access_token')
        localStorage.removeItem('expires_in')
        localStorage.removeItem('user');
        localStorage.removeItem('token_type');

        return true;
    },

    isAuthenticated () {
        if (this.getToken()) {
            return true;
        }
        else {
            return false;
        }
    }
}